import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { GuestRefundReasonService } from '../guest-refund-reason.service';
import { GuestRefundReasonComponent } from '../guest-refund-reason/guest-refund-reason.component';
import { GuestRefundReason } from '../guest-refund-reason';

@Component({
    selector: 'app-guest-refund-reason-list',
    templateUrl: './guest-refund-reason-list.component.html',
    styleUrls: ['./guest-refund-reason-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class GuestRefundReasonListComponent implements OnInit {
    reasonCodes: any;
	constructor(
		private guestRefundReasonService: GuestRefundReasonService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = guestRefundReasonService.statuses;
		this.reasonCodes = guestRefundReasonService.reasonCodes;
	}



	// data
	@Input() guestRefundId: any;
	@Input() guestRefundLastName: any;
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Output() totalRefundAmount = new EventEmitter<number>();
	@Output() totalRefundAmountDeduct = new EventEmitter<number>();
	guestRefundReasons: any;
	guestRefundReason: GuestRefundReason;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'guestRefundLastName', header: 'Name', width: 'auto' },
		{ field: 'refundAmount', header: 'Amount', width: 'auto' },
		{ field: 'reasonCode', header: 'Reason', width: 'auto' },
		{ field: 'reasonDesc', header: 'Description', width: 'auto' },
	];
	
	ngOnInit(): void {
	console.log('guestRefundId guestRefundId guestRefundId: ' + this.guestRefundId);
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.guestRefundReasonId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			// Fast path: when embedded in a guest refund, use the dedicated endpoint
			// (avoids the QueryDSL filter mismatch that fetches all records)
			if (this.guestRefundId) {
				this.guestRefundReasonService.findByGuestRefundId(this.guestRefundId).pipe(first()).subscribe(
					(res: any) => {
						this.guestRefundReasons = res.data.guestRefundReasons || [];
						this.recordTotal = this.guestRefundReasons.length;
						let amount = 0;
						for (const r of this.guestRefundReasons) {
							amount += r?.refundAmount || 0;
						}
						this.totalRefundAmount.emit(amount);
					},
					(err: any) => {
						console.log('findByGuestRefundId error: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);
				return;
			}

			// Generic path: no guestRefundId filter — use QueryDSL predicate endpoint
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.guestRefundReasonService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(
					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.guestRefundReasons = res.data.guestRefundReasons;
						let amount = 0;
						for (const r of this.guestRefundReasons) {
							amount += r?.refundAmount || 0;
						}
						this.totalRefundAmount.emit(amount);
					},
					(err: any) => {
						console.log('guestRefundReason list error: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.guestRefundReasons = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(guestRefundReason: GuestRefundReason) {
		try {
			this.formLoading = true;
			this.guestRefundReasonService.update(guestRefundReason)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.guestRefundReasons.map((guestRefundReason, i) => {
							if (guestRefundReason.guestRefundReasonId === res.data.guestRefundReason.guestRefundReasonId) {
								this.guestRefundReasons[i] = res.data.guestRefundReason;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(guestRefundReason: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(guestRefundReason));

			this.formLoading = true;
			this.guestRefundReasonService.delete(guestRefundReason.guestRefundReasonId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.guestRefundReasons.splice(this.guestRefundReasons.indexOf(guestRefundReason), 1);
						this.recordTotal = this.guestRefundReasons.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'GuestRefundReason ' + guestRefundReason.guestRefundReasonId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'GuestRefundReason ' + guestRefundReason.guestRefundReasonId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Refund Amount',
			guestRefundId: this.guestRefundId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(GuestRefundReasonComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				this.totalRefundAmount.emit(data.refundAmount);
				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addGuestRefundReasonCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(guestRefundReason: GuestRefundReason) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			guestRefundReason: guestRefundReason,
			title: 'Edit GuestRefundReason'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(GuestRefundReasonComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.totalRefundAmount.emit(data.refundAmount);
				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateGuestRefundReasonCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.totalRefundAmountDeduct.emit(data.refundAmount);
				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteGuestRefundReasonCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addGuestRefundReasonCB(guestRefundReason: GuestRefundReason) {
		console.log('Adding GuestRefundReason: ' + JSON.stringify(guestRefundReason));
		// if we don't have a guestRefundReasons array yet...
		if (!this.guestRefundReasons) {
			this.guestRefundReasons = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.guestRefundReasons.unshift(guestRefundReason);

		// no idea what this is but it is required to update the array
		this.guestRefundReasons = [...this.guestRefundReasons];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestRefundReason ' + guestRefundReason.guestRefundReasonId + ' Added', life: 3000 });
	}

	updateGuestRefundReasonCB(guestRefundReason: GuestRefundReason) {
		console.log('Updating GuestRefundReason: ' + JSON.stringify(guestRefundReason));
		let itemIndex = this.guestRefundReasons.findIndex((item: any) => item.guestRefundReasonId === guestRefundReason.guestRefundReasonId);
		this.guestRefundReasons[itemIndex] = guestRefundReason;

		// no idea what this is but it is required to update the array
		this.guestRefundReasons = [...this.guestRefundReasons];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestRefundReason ' + guestRefundReason.guestRefundReasonId + ' Updated', life: 3000 });
	}

	deleteGuestRefundReasonCB(guestRefundReason: GuestRefundReason) {
		console.log('Removing GuestRefundReason: ' + guestRefundReason);
		this.guestRefundReasons.splice(this.guestRefundReasons.indexOf(guestRefundReason), 1);
		this.recordTotal = this.guestRefundReasons.length;

		// no idea what this is but it is required to update the array
		this.guestRefundReasons = [...this.guestRefundReasons];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestRefundReason ' + guestRefundReason.guestRefundReasonId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.guestRefundReasons ? this.first === (this.guestRefundReasons.length - this.rows) : true; }
	isFirstPage(): boolean { return this.guestRefundReasons ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(guestRefundReason: any) {
		if (guestRefundReason?.status) {
			const status = this.statuses.find((e: any) => e.value == guestRefundReason.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getReasonCodeName(guestRefundReason: any) {
		if (guestRefundReason?.reasonCode) {
			const status = this.reasonCodes.find((e: any) => e.value == guestRefundReason.reasonCode);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
